/* src/app/rt-components/logo/logo.component.scss */
:host {
  display: block;
  height: 70px;
  width: 100%;
}
:host .logo {
  align-items: flex-end;
  display: flex;
  font-family: "Nunito Sans", sans-serif;
  height: 100%;
  padding: 5px 10px;
  text-decoration: none;
  background-color: #FFFFFF;
}
:host .logo .logo-img {
  height: auto;
  max-height: 100%;
  max-width: 100%;
  vertical-align: top;
  width: auto;
  background-color: #ffffff;
}
/*# sourceMappingURL=logo.component.css.map */
